
import React, { useState } from 'react';
import { useEffect } from 'react';
import DatePicker from 'react-datepicker';  // Import DatePicker
import "react-datepicker/dist/react-datepicker.css";  // Import date picker styles

import { IoMdCreate, IoIosMore, IoIosCalendar, IoIosCheckmark, IoIosClose, IoIosAddCircleOutline } from "react-icons/io";
import { Api } from '../../../../services/api';


function YaerPaln() {
    const [isAdmin, setIsAdmin] = useState(false);

    const [isEditing, setIsEditing] = useState(false);  // State to toggle edit mode
    const [formData, setFormData] = useState({
        futureDate: new Date('December 31, 2026'),
        revenue: [
            {
                description: 'Gross Sale Value',
                value: '10%'
            },
        ],
        profit: [
            {
                description: 'Gross Sale Value',
                value: '10%'
            },
        ],
        measurables: [
            {
                description: 'Gross Sale Value',
                value: '10%'
            },
        ],
        lookslike: [
            { label: '57 RP/RS', checked: false },
            { label: '1 President', checked: false },
            { label: '1 CFO / VP LIDA Group of Companies', checked: false },
            { label: '1 Development & Acquisition Manager', checked: false },
            { label: '3 Senior PM\'s', checked: false },
            { label: '1 VP Lida Partners', checked: false },
            { label: '1 Human Resources Manager contract', checked: false },
        ]
    });
    const [newMeasurableTitle, setNewMeasurableTitle] = useState(''); // To store the title for the new measurable
    const [isAddingMeasurable, setIsAddingMeasurable] = useState(false); // To control adding new measurable mode

    useEffect(() => {
        fetchData();
        const adminStatus = localStorage.getItem('isAdmin');
        setIsAdmin(adminStatus === 'Y');
    }, []);

    const fetchData = async () => {
        try {
            const token = localStorage.getItem('authToken');
            const response = await fetch(Api.API_BASE_URL + 'business-core/goal/one-year-plan/get', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token ? `Bearer ${token}` : '',
                },
            });
            const data = await response.json();
            if (data.result) {

                console.log(data)
                const { future_date, revenue, profit, measurables, lookslike } = data.result;

                // Check if futureDate is valid
                const parsedDate = new Date(future_date);
                const isValidDate = !isNaN(parsedDate.getTime()); 

                setFormData({
                    futureDate: isValidDate ? parsedDate : new Date(), 
                    revenue: revenue || [{ description: '', value: '' }],
                    profit: profit || [{ description: '', value: '' }],
                    measurables: measurables || [{ description: '', value: '' }],
                    lookslike: lookslike || formData.lookslike,
                });
            } else {
                setFormData({
                    futureDate: new Date(), 
                    revenue: [{ description: '', value: '' }],
                    profit: [{ description: '', value: '' }],
                    measurables: [{ description: '', value: '' }],
                    lookslike: formData.lookslike,
                });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleEdit = () => {
        setIsEditing(true);
    };

    const handleSave = async () => {
        setIsEditing(false);
        try {
            const token = localStorage.getItem('authToken');
            const payload = {

                revenue: formData.revenue,
                profit: formData.profit,
                measurables: formData.measurables,
                lookslike: formData.lookslike,
                futureDate: formData.futureDate,

            };

            const response = await fetch(Api.API_BASE_URL + 'business-core/goal/one-year-plan/save', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token ? `Bearer ${token}` : ''
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const result = await response.json();
            console.log('Data saved successfully:', result);
        } catch (error) {
            console.error('Error saving data:', error);
        }
    };


    const handleDateChange = (date) => {
        setFormData({
            ...formData,
            futureDate: date,
        });
    };




    // Handle changes in the input fields Revenue

    const handleRevenueChange = (e, field, index) => {
        const newRevenue = [...formData.revenue];
        newRevenue[index][field] = e.target.value;
        setFormData({
            ...formData,
            revenue: newRevenue,
        });
    };
    // Add a new row to the revenue
    const handleAddRow = () => {
        setFormData({
            ...formData,
            revenue: [
                ...formData.revenue,
                { description: '', value: '' },
            ],
        });
    };

    // Handle deletion of a row
    const handleDeleteRow = (index) => {
        const newRevenue = [...formData.revenue];
        newRevenue.splice(index, 1);
        setFormData({
            ...formData,
            revenue: newRevenue,
        });
    };

    const handleProfitChange = (e, field, index) => {
        const newProfit = [...formData.profit];
        newProfit[index][field] = e.target.value;
        setFormData({
            ...formData,
            profit: newProfit,
        });
    };


    const handleAddRowProfit = () => {
        setFormData({
            ...formData,
            profit: [
                ...formData.profit,
                { description: '', value: '' },
            ],
        });
    };

    // Handle deletion of a row

    const handleDeleteRowProfit = (index) => {
        const newProfit = [...formData.profit];
        newProfit.splice(index, 1);
        setFormData({
            ...formData,
            profit: newProfit,
        });
    };

    const handleMeasurablesChange = (e, field, index) => {
        const newMeasurables = [...formData.measurables];
        newMeasurables[index][field] = e.target.value;
        setFormData({
            ...formData,
            measurables: newMeasurables,
        });
    };
    // Add a new row with empty values

    const handleAddRowMeasurables = () => {
        setFormData({
            ...formData,
            measurables: [
                ...formData.measurables,
                { description: '', value: '' },
            ],
        });
    };

    // Handle deletion of a row handleDeleteRowMeasurables

    const handleDeleteRowMeasurables = (index) => {
        const newMeasurables = [...formData.measurables];
        newMeasurables.splice(index, 1);
        setFormData({
            ...formData,
            measurables: newMeasurables,
        });
    };

    // Handle changes in the input fields Measurable end


    const handleCheckboxChange = (index) => {
        const newLookslike = [...formData.lookslike];
        newLookslike[index].checked = !newLookslike[index].checked;
        setFormData({
            ...formData,
            lookslike: newLookslike,
        });
    };

    const handleAddMeasurable = () => {
        setIsAddingMeasurable(true); // Show input field for new measurable title
    };

    const handleSaveNewMeasurable = () => {
        if (newMeasurableTitle.trim()) {
            const newLookslike = { label: newMeasurableTitle, checked: false };
            setFormData({
                ...formData,
                lookslike: [...formData.lookslike, newLookslike],
            });
            setNewMeasurableTitle(''); // Reset title input
            setIsAddingMeasurable(false); // Hide input field after saving
        }
    };



    // Custom input component to include the calendar icon
    const CustomDateInput = ({ value, onClick }) => (
        <div className="custom-date-input">
            <input
                type="text"
                value={value}
                onClick={onClick}  // Trigger the calendar pop-up when clicked
                readOnly
                className="effect-1"  // Optional styling
                placeholder="Select a date"
                style={{
                    width: '100%',
                }}
            />
            <IoIosCalendar
                onClick={onClick}  // Allow the calendar to open when the icon is clicked
                style={{ fontSize: '20px', position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}
            />
        </div>
    );


    return (
        <div className="box2">
            <div className="box-header">
                <h4 className='subtitle-font'>1-Year Plan</h4>
                {isAdmin && (
                    <IoMdCreate
                        onClick={handleEdit}
                        style={{
                            fontSize: '20px',
                            cursor: 'pointer',
                        }}
                    />
                )}
            </div>

            <div className="box-body" style={{ fontFamily: 'Arial, sans-serif' }}>
                <div className="box-title">
                    {isEditing ? (
                        <DatePicker
                            selected={formData.futureDate}  // Use the Date object
                            onChange={handleDateChange}  // Handle date change
                            dateFormat="MMMM d, yyyy"  // Format date as "Month day, year"
                            customInput={<CustomDateInput />}  // Custom input with calendar icon
                            style={{
                                display: 'flex',
                            }}
                        />
                    ) : (
                        <h4>Future Date: <span className='text-grey'>{formData.futureDate.toLocaleDateString()}</span></h4>  // Display formatted date
                    )}
                </div>
                {/* Display the revenue add */}
                <div className="box-title d-flex justify-content-between align-items-center">
                    <h4 className="m-2" >Revenue:
                        {isEditing && (
                            <IoIosAddCircleOutline
                                onClick={handleAddRow}
                                style={{
                                    fontSize: '20px',
                                    cursor: 'pointer',
                                    verticalAlign: 'middle',
                                }}
                            />
                        )}

                    </h4>

                    {/* Display the revenue table */}
                    <table className="table table-borderless mt-2">
                        <tbody>
                            {formData.revenue.map((row, index) => (
                                <tr key={index}>
                                    <td className="text-grey p-2">
                                        {isEditing ? (
                                            <>
                                                <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px' }}>
                                                    Description
                                                </label>
                                                <input
                                                    type="text"
                                                    value={row.description}
                                                    onChange={(e) => handleRevenueChange(e, 'description', index)}
                                                    className='effect-1' />
                                            </>
                                        ) : (
                                            row.description
                                        )}
                                    </td>
                                    <td className="text-grey p-2">
                                        {isEditing ? (
                                            <><label style={{ display: 'block', marginBottom: '5px', fontSize: '12px' }}>
                                                Value
                                            </label>
                                                <input
                                                    type="text"
                                                    value={row.value}
                                                    onChange={(e) => handleRevenueChange(e, 'value', index)}
                                                    className='effect-1' />
                                            </>
                                        ) : (
                                            row.value
                                        )}
                                    </td>
                                    {isEditing && (
                                        <td>
                                            <IoIosClose
                                                onClick={() => handleDeleteRow(index)} // Delete row when icon is clicked
                                                style={{
                                                    fontSize: '30px',
                                                    cursor: 'pointer',
                                                    color: 'red',
                                                }}
                                            />
                                        </td>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {/* Display the profit add */}
                <div className="box-title">
                    <h4 className="m-2" >Profit:
                        {isEditing && (
                            <IoIosAddCircleOutline
                                onClick={handleAddRowProfit}
                                style={{
                                    fontSize: '20px',
                                    cursor: 'pointer',
                                    verticalAlign: 'middle',
                                }}
                            />
                        )}

                    </h4>

                    {/* Display the profit table */}
                    <table className="table table-borderless mt-2">
                        <tbody>
                            {formData.profit.map((row, index) => (
                                <tr key={index}>
                                    <td className="text-grey p-2">
                                        {isEditing ? (
                                            <>
                                                <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px' }}>
                                                    Description
                                                </label>
                                                <input
                                                    type="text"
                                                    value={row.description}
                                                    onChange={(e) => handleProfitChange(e, 'description', index)}
                                                    className='effect-1' />
                                            </>
                                        ) : (
                                            row.description
                                        )}
                                    </td>
                                    <td className="text-grey p-2">
                                        {isEditing ? (
                                            <>
                                                <label style={{ display: 'block', marginBottom: '5px', fontSize: '12px' }}>
                                                    Description
                                                </label>
                                                <input
                                                    type="text"
                                                    value={row.value}
                                                    onChange={(e) => handleProfitChange(e, 'value', index)}
                                                    className='effect-1' />
                                            </>
                                        ) : (
                                            row.value
                                        )}
                                    </td>
                                    {isEditing && (
                                        <td>
                                            <IoIosClose
                                                onClick={() => handleDeleteRowProfit(index)} // Delete row when icon is clicked
                                                style={{
                                                    fontSize: '30px',
                                                    cursor: 'pointer',
                                                    color: 'red',
                                                }}
                                            />
                                        </td>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>


                <div className="box-title">
                    <h4 className="m-2" >Measurables:
                        {isEditing && (
                            <IoIosAddCircleOutline
                                onClick={handleAddRowMeasurables}
                                style={{
                                    fontSize: '20px',
                                    cursor: 'pointer',
                                    verticalAlign: 'middle',
                                }}
                            />
                        )}

                    </h4>

                    {/* Display the profit table */}
                    <table className="table table-borderless mt-2">
                        <tbody>
                            {formData.measurables.map((row, index) => (
                                <tr key={index}>
                                    <td className="text-grey p-2">
                                        {isEditing ? (
                                            <>
                                                <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px' }}>
                                                    Description
                                                </label>
                                                <input
                                                    type="text"
                                                    value={row.description}
                                                    onChange={(e) => handleMeasurablesChange(e, 'description', index)}
                                                    className='effect-1' />
                                            </>
                                        ) : (
                                            row.description
                                        )}
                                    </td>
                                    <td className="text-grey p-2">
                                        {isEditing ? (
                                            <>
                                                <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px' }}>
                                                    Description
                                                </label>
                                                <input
                                                    type="text"
                                                    value={row.value}
                                                    onChange={(e) => handleMeasurablesChange(e, 'value', index)}
                                                    className='effect-1' />
                                            </>
                                        ) : (
                                            row.value
                                        )}
                                    </td>
                                    {isEditing && (
                                        <td>
                                            <IoIosClose
                                                onClick={() => handleDeleteRowMeasurables(index)} // Delete row when icon is clicked
                                                style={{
                                                    fontSize: '30px',
                                                    cursor: 'pointer',
                                                    color: 'red',
                                                }}
                                            />
                                        </td>
                                    )}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>



                <div className="box-title1 d-flex align-items-center">
                    <h4 className="m-2" style={{ marginRight: '8px' }}>
                        Goals for the Year :
                        {isEditing && (
                            <IoIosAddCircleOutline
                                onClick={handleAddMeasurable}
                                style={{
                                    fontSize: '20px',
                                    cursor: 'pointer',
                                    verticalAlign: 'middle',  // Ensure the icon aligns vertically with the text
                                }}
                            />
                        )}

                    </h4>

                </div>



                {/* Show input field when adding new measurable */}
                {isEditing && isAddingMeasurable && (
                    <div className="mt-3 d-flex justify-content-center ">
                        <input
                            type="text"
                            value={newMeasurableTitle}
                            onChange={(e) => setNewMeasurableTitle(e.target.value)}
                            placeholder="Enter measurable title"
                            className='effect-1'
                        />
                        <IoIosCheckmark
                            onClick={handleSaveNewMeasurable}
                            style={{
                                paddingTop: '10px',
                                fontSize: '40px',
                                cursor: 'pointer',
                            }}
                        />

                    </div>
                )}
                <div className="box-title">
                    {formData.lookslike.map((item, index) => (
                        <div className="form-check mb-2" key={index}>
                            <div className="row">
                                <div className="col-1">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        checked={item.checked}
                                        onChange={() => handleCheckboxChange(index)}
                                        disabled={!isEditing}  // Disable checkbox unless in edit mode
                                    />
                                </div>
                                <div className="col-9">
                                    <label className="form-check-label spaceclas">{item.label}</label>
                                </div>
                                <div className="col-2">
                                    <IoIosMore />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {/* Button to add new measurable */}


                {isEditing && (
                    <button onClick={handleSave} className="customSave-button m-2 flex">
                        Save
                    </button>
                )}

            </div>
        </div>
    );
}

export default YaerPaln;
